import { defineStore } from 'pinia'
import { ref } from 'vue'
const useLoadingsStore = defineStore('loading', () => {
  const loading = ref<boolean>(false)
  const localeLoading = ref<boolean>(false)
  const loadingMsg = ref<string>('receive.scan.loading')

  const openSpinner = () => {
    loading.value = true
  }

  const closeSpinner = () => {
    loadingMsg.value = 'receive.scan.loading'
    loading.value = false
  }

  const setLoadingMsg = (msg: string) => {
    loadingMsg.value = msg
  }

  return {
    loading,
    localeLoading,
    openSpinner,
    closeSpinner,
    loadingMsg,
    setLoadingMsg,
  }
})

export { useLoadingsStore }
